import React from 'react'
import { useLocation } from 'react-router-dom'
import { resolveRouteAccessPolicy } from '@/routes/accessPolicy'
import { RequireAuth } from './RequireAuth'

interface RouteAccessGateProps {
  children: React.ReactNode
}

export function RouteAccessGate({ children }: RouteAccessGateProps) {
  const location = useLocation()
  const policy = resolveRouteAccessPolicy(location.pathname)

  if (!policy.requiresAuth) {
    return <>{children}</>
  }

  return (
    <RequireAuth roles={policy.roles} showAccessDenied>
      {children}
    </RequireAuth>
  )
}
